<template>
  <div class="listOrder">
        <div class="listBox">
            <div class="back" @click="back">&lt;&nbsp;返回</div>
            <div class="infor">订单列表</div>
            <div style="margin-top: .4375rem;margin-left: .3875rem;margin-right: .3rem;">
                <el-table :data="tableData" style="width: 100%"
                    :header-cell-style="{ 'background': '#EEEEEE !important', 'color': '#333', 'height': '.7rem !important' }">
                    <el-table-column type="index" label="序号" width="180" />
                    <el-table-column prop="materialTime" label="物料到厂时间" width="260px" />
                    <el-table-column prop="shipmentTime" label="出货时间"  width="220"/>
                    <el-table-column prop="shipmentDestination" label="交货目的地" />
                    <el-table-column prop="orderNumber" label="订单编号" width="220"/>
                    <el-table-column prop="orderState" label="订单状态" />
                    <el-table-column label="操作">
                        <template #default="scope">
                            <el-button link type="primary" size="small" class="caozuoBtn"
                            @click="handleClick(scope.row.orderId,2)">查看详情</el-button>
                            <el-button link type="primary" size="small" class="caozuoBtn"
                            @click="acceptOrder(scope.row.orderId)">接单</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { plantOrderData } from "@/api/mange.js"
import { getDicts,factoryAcceptOrder } from "@/api/order.js"
import { useRouter, useRoute } from 'vue-router';
import { ElMessage,ElMessageBox } from 'element-plus'
const tableData = ref([])
const stateData = ref([])
const router = useRouter()
onMounted(() => {
    getDicts('order_state').then(res => {
        stateData.value = res.data.data
    })
    getPlantData()
})

const handleClick = (orderId,roleType) => {
    // router.push("/orderDetail")
    router.push({ path: '/orderDetail', query: { orderId: orderId,roleType:roleType } })
}

const getPlantData = () => {
    plantOrderData({orderState:1}).then(res => {
        tableData.value = []
        tableData.value = res.data.rows
        stateData.value.map((item, index) => {
            tableData.value.map((val, index) => {
                if (val.orderState == item.dictValue) {
                    val.orderState = item.dictLabel
                }
            })
        })
    })
}
const acceptOrder = (val) => {
    ElMessageBox.confirm(
    '是否确认接此订单，一旦接单，无法更改',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    factoryAcceptOrder(val).then(res => {
        if(res.data.code == 200) {
            ElMessage.success("接单成功")
            getPlantData()
        }
    })
    })
}


const back = () => {
    router.push("/index")
}
</script>

<style scoped>
.listOrder {
    background: #F8F8F8;
    /* border-radius: 0px 0px 0px 0px; */
    overflow: hidden;
}
.listBox {
    height: 11.85rem;
    background: #FFFFFF;
    /* border-radius: 0px 0px 0px 0px; */
    opacity: 1;
    margin-left: 3.25rem;
    margin-right: 3.25rem;
    margin-top: 1.275rem;
    overflow: hidden;
}
.back {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: left;
    margin-left: .425rem;
    margin-top: .3rem;
    cursor: pointer;
}
.infor {
    height: .6375rem;
    background: #EEEEEE;
    /* border-radius: 0px 0px 0px 0px; */
    opacity: 1;
    margin-left: .35rem;
    margin-right: .35rem;
    margin-top: .2625rem;
    line-height: .6375rem;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 700;
    color: #000000;
    text-align: left;
    padding-left: .25rem;
}
::v-deep .el-table .el-table__cell {
    text-align: center;
}
</style>
